import type { ActiveFilter, ReadyMembersState } from "./types"

/**
 * The filters a consumer may present as applied: one entry per selected
 * facet option, labelled "Facet: Option", then the applied text if any.
 */
export function activeFilters(state: ReadyMembersState): ActiveFilter[] {
  const filters: ActiveFilter[] = state.facets.flatMap((facet) =>
    facet.options
      .filter((option) => option.selected)
      .map((option) => ({
        kind: "facet" as const,
        facetId: facet.id,
        value: option.value,
        label: `${facet.label}: ${option.label}`,
      })),
  )
  if (state.text !== "") filters.push({ kind: "text", text: state.text })
  return filters
}
